import type { CanvasClipboard } from './types';

let clipboard: CanvasClipboard | null = null;

export const getClipboard = (): CanvasClipboard | null => clipboard;
export const setClipboard = (c: CanvasClipboard | null): void => { clipboard = c; };
